<script lang="ts">

	import type { TeaserContent } from '../../../domain/teaser/TeaserContent.ts';
	import { toSignUpSheet } from '../../../domain/SheetData.ts';
	import { TeaserType } from '../../../domain/teaser/TeaserType.ts';
	import { trackClick, trackSeen, trackView } from '../../../services/tracking/TeaserTracking.ts';
	import { onMount } from 'svelte';
	import TrackingService from '../../../services/tracking/TrackingService.ts';
	import { onViewport } from '../../../services/tracking/IntersectionObserver';

	let { teaserContent }: {
		teaserContent: TeaserContent
	} = $props();

	const teaserContainerMargin = teaserContent.isProductList ? '' : 'oc-mx-100';

	let teaser: Element;
	const teaserSize = 'MediaObject100';
	const teaserType = TeaserType.BOOSTER_TEASER;
	const isBoosterTeaser = true;

	let headline = $state(teaserContent.heading);
	const signUpSheetData: string = getSheetData();

	function getSheetData() {
		return JSON.stringify(toSignUpSheet(teaserType, teaserContent, undefined));
	}

	let trackingService: TrackingService;

	onMount(() => {
		trackingService = new TrackingService();

		trackClick(trackingService, teaser, teaserContent, teaserType, teaserSize, isBoosterTeaser);
		trackView(trackingService, teaser, teaserContent, teaserType, teaserSize, isBoosterTeaser);
	});
</script>

<div class="oc-mt-100 oc-mb-150 {teaserContainerMargin}"
	bind:this={teaser}
	data-oc-sheet-v1-create={signUpSheetData}
	data-testid="up-booster-teaser-l-container"
	id="teaser-container"
	onenterViewport={() => trackSeen(trackingService)}
	use:onViewport>
	<oc-media-object-card-v2
		data-testid="to-booster-teaser-card"
		as-button=""
		variant="ambient-image"
		background-color="#FFFFFF"
		size="100"
		elevation-level="canvas"
		oc-aria-label="Wechsel auf OTTO UP Plus"
	>
		<picture slot="img">
			<img
				loading="eager"
				src="https:/*                                                                                         */
				aria-hidden="true"
			/>
		</picture>
		<div id="headline" slot="headline">{headline}</div>
		<div id="subline" slot="subline">{teaserContent?.subheading}</div>
	</oc-media-object-card-v2>
</div>
